<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Relatório</span>
        <h3 class="page-title d-inline">Produtos</h3>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-12">
              <h6 class="m-0">Produtos Publicados</h6>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <product-table :products="products.list" />
            </div>
            <pagination :total-items="products.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import ReportService from '_services/rest/modules/report';
import ProductTable from '../components/ProductTable.vue';

export default {
  name: 'report-product-list',
  components: {
    Pagination,
    ProductTable,
  },
  data() {
    return {
      products: {
        list: [],
        total_items: null,
      },
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    getList() {
      ReportService.getProductList(this.pagination)
        .then(response => {
          this.products = response;
          this.setToggle({ type: 'progress', bool: false });
        });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },

};
</script>

<style lang="scss" scoped>
</style>
